import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=0003385c&"
import script from "./CourseInfo.vue?vue&type=script&lang=ts&"
export * from "./CourseInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports